export interface Category {
  name: string;
  url: string;
  seq: string;
}

export const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', seq: 'cat-shoes' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html', seq: 'cat-hoodies' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html', seq: 'cat-tshirts' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html', seq: 'cat-jackets' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html', seq: 'cat-pants' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html', seq: 'cat-headwear' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html', seq: 'cat-sets' },
  { name: 'underwear/underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html', seq: 'cat-underwear' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html', seq: 'cat-jersey' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html', seq: 'cat-accessories' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html', seq: 'cat-bags' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html', seq: 'cat-belts' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html', seq: 'cat-perfumes' },
  { name: 'OtherStuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html', seq: 'cat-otherstuff' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const articleGuides = [
  {
    title: 'Best Mulebuy Spreadsheet List 2026',
    subtitle: 'Updated verified spreadsheet collections',
    seq: 'guide-list',
    path: '/mulebuy-spreadsheet-guide',
  },
  {
    title: 'Mulebuy Spreadsheet vs Agents',
    subtitle: 'Comparison guide for smart buyers',
    seq: 'guide-vs',
    path: '/mulebuy-spreadsheet-guide',
  },
  {
    title: 'Beginner Guide to Spreadsheet',
    subtitle: 'Start your sourcing journey right',
    seq: 'guide-beginner',
    path: '/mulebuy-spreadsheet-guide',
  },
  {
    title: 'Safety Guide for Users',
    subtitle: 'Stay secure while sourcing products',
    seq: 'guide-safety',
    path: '/mulebuy-spreadsheet-guide',
  },
];

export const testimonials = [
  {
    name: 'Marcus Chen',
    role: 'Small Business Owner',
    text: 'The mulebuy spreadsheet completely changed how I source products. I found verified agent data that saved me hours of manual research. The structured format makes price comparison effortless and helps me make smarter purchasing decisions every week.',
    avatar: 'MC',
  },
  {
    name: 'Sarah Williams',
    role: 'Online Reseller',
    text: 'I have been searching for reliable mulebuy spreadsheet lists for months before finding this site. The comparison tools and verified agent information helped me increase my profit margins by over 30% within the first quarter. Highly recommended for any serious buyer.',
    avatar: 'SW',
  },
  {
    name: 'David Park',
    role: 'E-commerce Consultant',
    text: 'As someone who recommends sourcing tools to clients daily, the mulebuy spreadsheet resources here are among the best organized I have encountered. The regularly updated data and clear agent comparisons make it an essential resource for anyone in the buying community.',
    avatar: 'DP',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Fashion Retailer',
    text: 'Finding accurate product data was always a challenge until I discovered this mulebuy spreadsheet hub. The structured approach to organizing agent and product information has streamlined my entire sourcing workflow. The time savings alone made it completely worth exploring.',
    avatar: 'ER',
  },
  {
    name: 'James Thompson',
    role: 'Dropshipping Expert',
    text: 'I have tested dozens of sourcing tools and spreadsheet solutions over the years, and the mulebuy spreadsheet data curated here stands out for its accuracy and organization. The regular updates mean I am never working with outdated product or agent information.',
    avatar: 'JT',
  },
  {
    name: 'Lisa Zhang',
    role: 'Product Sourcing Manager',
    text: 'The mulebuy spreadsheet resources on this site gave my team a significant efficiency boost. We reduced our product research time by nearly half after implementing the structured data and agent comparison methods we found here. A truly valuable resource for sourcing professionals.',
    avatar: 'LZ',
  },
];

export const featuredSpreadsheets = [
  { name: 'Mulebuy Sheet A', frequency: 'Daily', reliability: 'High', features: 'Full data set', bestFor: 'Beginners' },
  { name: 'Mulebuy Sheet B', frequency: 'Weekly', reliability: 'Medium', features: 'Price tracking', bestFor: 'Advanced users' },
  { name: 'Mulebuy Sheet C', frequency: 'Real-time', reliability: 'High', features: 'Auto sync tools', bestFor: 'Professionals' },
  { name: 'Mulebuy Sheet D', frequency: 'Bi-weekly', reliability: 'High', features: 'Agent comparison', bestFor: 'All levels' },
];